import styled from 'styled-components';
import IconButton from 'components/IconButton';
import Spacer from 'components/Spacer';
import { Text } from 'components/Typography';
import { getThemeColor } from 'utils/styled';
import { ChipStyleProps } from './types';

export const Root = styled(Spacer).attrs({
  align: 'center',
})<ChipStyleProps>`
  height: 30px;
  padding: ${({ $permanent }) =>
    $permanent ? '7px 15px' : '7px 8px 7px 15px'};
  border-radius: 15px;
  background-color: ${getThemeColor('l4')};
  color: ${getThemeColor('d1')};
`;

export const Content = styled(Text).attrs({
  variant: 'p',
})`
  line-height: normal;
`;

export const CloseButton = styled(IconButton)`
  color: ${getThemeColor('d5')};
  width: 14px;
  height: 14px;
`;
